import { Project } from '../../team-apis/otterdam/project';
import { isSensorFusionOutput } from './output-utils';

export function getTotalFusedOutputs(project: Project) {
  const fusionOutput = project.outputs.find(isSensorFusionOutput);
  return fusionOutput?.meta.fused_outputs.length ?? 0;
}
